require('./TimeLine.scss');

const b = require('app/www/libs/b')('time-line', true);

const React = require('react');
const PropTypes = require('prop-types');

const {withReq} = require('app/www/components/contexts/Req');
const {withI18n} = require('app/www/components/contexts/I18n');

const PageVisibilityAware = require('app/www/components/blocks/PageVisibilityAware/PageVisibilityAware');

const UPDATE_INTERVAL = 60000;

class TimeLine extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            progress: this._progress,
            summary: '',
        };

        this._update = this._update.bind(this);
        this._listenPageVisibility = this._listenPageVisibility.bind(this);
        this._stopInterval = this._stopInterval.bind(this);
        this._isViewInIframeKinopoiskhd = this.props.req.lib('urlBuilder').isViewInIframeKinopoiskhd;
    }

    componentDidMount() {
        this._update(true);
        this._interval = setInterval(this._update, UPDATE_INTERVAL);
    }

    componentWillUnmount() {
        this._stopInterval();
        this._update = () => {};
    }

    render() {
        const {
            title,
            className,
            showSummary,
            onStartEvent,
            currentEvent,
        } = this.props;

        const {progress, summary} = this.state;

        const pathStyle = {
            width: `${Math.round(100 * progress)}%`,
        };

        if (progress <= 0 || progress === 1) {
            return null;
        }

        if (currentEvent && title) {
            onStartEvent(title);
        }

        return (
            <div className={b.mix(className)}>
                <div className={b('path', {dark: this._isViewInIframeKinopoiskhd})} style={pathStyle} />
                {showSummary && <div className={b('summary')}>{summary}</div>}
                <PageVisibilityAware callback={this._listenPageVisibility}/>
            </div>
        );
    }

    /**
     * @private
     */
    _update(hasInited) {
        const {
            req,
            start,
            showSummary,
            onStart,
        } = this.props;

        const moment = req.lib('moment');
        const progress = this._progress;
        const difference = moment.diff('minutes', start);

        if (progress >= 0 && progress < 1) {
            onStart(progress);
        }

        if (progress === 1 && !hasInited) {
            this._stopInterval();
        }

        this.setState({
            progress,
            summary: showSummary ? this._getSummary(difference) : '',
        });
    }

    /**
     * @private
     */
    _stopInterval() {
        clearInterval(this._interval);
        this._interval = null;
    }

    /**
     * Получаем текст о наступлении события
     * @param {Number} difference количество миллисекунд от текущего момента до начала события
     * @returns {String}
     * @private
     */
    _getSummary(difference) {
        const {req, i18n} = this.props;
        const moment = req.lib('moment');
        const moreHour = Math.abs(difference) >= moment.MUNITES_IN_HOUR;
        const state = difference > 0 ? 'passed' : 'after';

        const number = Math.abs(Math.round(
            moreHour ? difference / moment.MUNITES_IN_HOUR : difference
        ));

        const units = !number ? 'seconds'
            : moreHour ? 'hours' : 'minutes';

        return i18n.get(`time-line.${state}.${units}`, number, {number});
    }

    /**
     * Window in focus.
     * @param {Boolean} isHidden вкладка не активна
     * @private
     */
    _listenPageVisibility(isHidden) {
        if (isHidden) {
            this._stopInterval();
        } else {
            this._update(true);
            this._interval = setInterval(this._update, UPDATE_INTERVAL);
        }
    }

    /**
     * @returns {Number}
     * @private
     */
    get _progress() {
        if (this.props.progress) {
            return this.props.progress;
        }

        const {req, start, finish} = this.props;
        const moment = req.lib('moment');

        const difference = moment.diff('minutes', start);
        const duration = moment.diff('minutes', start, finish);

        return Math.min(difference / duration, 1);
    }

}

TimeLine.defaultProps = {
    showSummary: false,
    onStart: () => {},
    onFinish: () => {},
    onStartEvent: () => {},
};

TimeLine.propTypes = {
    start: PropTypes.string.isRequired,
    finish: PropTypes.string.isRequired,
    progress: PropTypes.number,
    showSummary: PropTypes.bool,
    onStart: PropTypes.func,
};

module.exports = withReq(withI18n(TimeLine));
